import { render, staticRenderFns } from "./Rolesetting.vue?vue&type=template&id=47d3a898&scoped=true&"
import script from "./Rolesetting.vue?vue&type=script&lang=js&"
export * from "./Rolesetting.vue?vue&type=script&lang=js&"
import style0 from "./Rolesetting.vue?vue&type=style&index=0&id=47d3a898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d3a898",
  null
  
)

export default component.exports